<template>
  <div
    class="inline-flex shrink-0 items-baseline rounded-full font-medium"
    :class="[variantClass, toneClass]"
  >
    <IconArrowUp
      v-if="props.direction === 'up'"
      class="mr-[2px] shrink-0 self-center"
      :class="[iconSizeClass, iconClass]"
      aria-hidden="true"
    />
    <IconArrowDown
      v-else-if="props.direction === 'down'"
      class="mr-[2px] shrink-0 self-center"
      :class="[iconSizeClass, iconClass]"
      aria-hidden="true"
    />
    <span class="sr-only">
      {{ srLabel }}
    </span>
    {{ valueText }}
  </div>
</template>

<script setup lang="ts">
export type ComparisonChipTone =
  | "positive"
  | "negative"
  | "neutral"

export type ComparisonChipDirection = "up" | "down" | "flat"

const props = withDefaults(
  defineProps<{
    value: string | number | undefined
    srLabel?: string
    variant?: "platform" | "sidebar"
    tone?: ComparisonChipTone
    direction?: ComparisonChipDirection
  }>(),
  {
    srLabel: "Comparison change",
    variant: "platform",
    tone: "neutral",
    direction: "down",
  }
)

const valueText = computed(() =>
  props.value === undefined ? "-" : props.value
)

const variantClass = computed(() =>
  props.variant === "sidebar"
    ? "px-1.5 py-0.5 text-[10px] text-background-fg/70"
    : "px-2.5 py-0.5 text-sm text-neutral-500"
)

const iconSizeClass = computed(() =>
  props.variant === "sidebar" ? "size-2.5" : "size-3"
)

const toneClassMap: Record<ComparisonChipTone, string> = {
  positive: "bg-positive/8",
  negative: "bg-error/8",
  neutral: "bg-background-fg/8",
}

const iconClassMap: Record<ComparisonChipTone, string> = {
  positive: "text-positive",
  negative: "text-error",
  neutral: "text-background-fg/50",
}

const toneClass = computed(() => toneClassMap[props.tone])

const iconClass = computed(() => iconClassMap[props.tone])
</script>
